module.exports = __webpack_public_path__ + "img/dotted-arrow.f2972fca.svg";